module.exports = __webpack_public_path__ + "img/logo.10c151e8.png";